export default __webpack_public_path__ + "static/media/EAST3090.34I-39625_-23468_0.124436cd.jpg";